import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0061B2",
    },
  },
  colors: {
    black: "#21201E",
    white: "#FEFEFE",
    gray1: "#444444",
    gray2: "#707070",
    gray3: "#BBBCBE",
    gray4: "#D5D5D7",
    darkBlue: "#0061B2",
    lightBlue: "#0088DF",
  },
});

export default theme;
